import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-24d7761e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "edit-page-keywords",
  style: {
    "display": "grid"
  }
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "keywords-top"
};
const _hoisted_4 = {
  class: "keywords-top-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "keywords-top-title-text"
}, "Keyword manager", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "keywords-description"
}, " Use this tool to identify the best keywords for your products, check their usage in your listings, and add any missing keywords to improve visibility and search rankings. ", -1));
const _hoisted_7 = {
  class: "search-bar"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "apply-keywords-popover-content"
}, [/*#__PURE__*/_createElementVNode("span", null, " Omny AI has carefully selected keywords to optimize your Amazon Seller Central search terms, ensuring maximum effectiveness and visibility. ")], -1));
const _hoisted_9 = {
  class: "suggested-keywords-section"
};
const _hoisted_10 = {
  class: "keyword-table"
};
const _hoisted_11 = {
  key: 1,
  class: "no-keywords"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/empty-keywords-img.svg"
}, null, -1));
const _hoisted_13 = {
  class: "no-keywords-text"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " No relevant keywords found", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "body"
}, "No relevant keywords are found for this product.", -1));
const _hoisted_16 = {
  class: "link"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_18 = ["onMouseover", "onClick"];
const _hoisted_19 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_input = _resolveComponent("app-input");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_apply_keywords_icon = _resolveComponent("apply-keywords-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_b_row = _resolveComponent("b-row");
  const _component_table_skeleton_v2 = _resolveComponent("table-skeleton-v2");
  const _component_b_th = _resolveComponent("b-th");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_thead = _resolveComponent("b-thead");
  const _component_Popper = _resolveComponent("Popper");
  const _component_b_td = _resolveComponent("b-td");
  const _component_product_score = _resolveComponent("product-score");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_app_icon, {
    icon: "keywords",
    color: "#4D4D4D"
  }), _hoisted_5]), _createElementVNode("div", {
    class: "keywords-top-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: "20",
    color: "#616161"
  })])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_app_input, {
    modelValue: $data.search,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.search = $event),
    placeholder: "Search...",
    v2: "",
    version: "search",
    style: {
      "width": "-webkit-fill-available"
    }
  }, null, 8, ["modelValue"])]), !$data.loading && $data.keywords.length ? (_openBlock(), _createBlock(_component_b_row, {
    key: 0,
    class: "keywords-count-and-apply"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      cols: "4"
    }, {
      default: _withCtx(() => [_createElementVNode("b", null, _toDisplayString($options.keywordsFiltered.length), 1), _createTextVNode(" keywords ")]),
      _: 1
    }), _createVNode(_component_b_col, {
      cols: "8",
      class: "apply-keywords",
      onClick: $options.onApplyKeywords,
      id: "apply-keywords"
    }, {
      default: _withCtx(() => [$data.apply_keywords_loading ? (_openBlock(), _createBlock(_component_b_spinner, {
        key: 0,
        small: ""
      })) : (_openBlock(), _createBlock(_component_apply_keywords_icon, {
        key: 1
      })), _createTextVNode(" Apply suggested keywords to search term ")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_app_popover, {
      target: 'apply-keywords',
      "auto-width": "",
      placement: "top",
      "custom-class": "apply-keywords-popover"
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [$data.loading ? (_openBlock(), _createBlock(_component_table_skeleton_v2, {
    key: 0,
    fields: $data.fields,
    class: "keyword-loading-table"
  }, null, 8, ["fields"])) : _createCommentVNode("", true), !$data.loading && !$data.keywords.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("div", _hoisted_16, [_createVNode(_component_app_icon, {
    icon: "tool",
    color: "#1755AB",
    size: 18
  }), _createTextVNode(" Connect your advertising account "), _hoisted_17, _createTextVNode(" to get keyword recommendation")])])])) : _createCommentVNode("", true), !$data.loading && $data.keywords.length ? (_openBlock(), _createBlock(_component_b_table_simple, {
    key: 2,
    striped: "",
    style: {
      "margin-bottom": "0px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_b_thead, {
      class: "keyword-table-thead-background"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_tr, null, {
        default: _withCtx(() => [_createVNode(_component_b_th, {
          class: "keyword-table-thead-background-text"
        }, {
          default: _withCtx(() => [_createTextVNode("Keyword")]),
          _: 1
        }), _createVNode(_component_b_th, {
          class: "keyword-table-thead-background-text"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "th sortable",
            onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.onSort('keyword_usage'), ["stop"]))
          }, [_createTextVNode(" Usage "), _createVNode(_component_app_icon, {
            icon: `chevron-down2`,
            color: $data.sortField == 'keyword_usage' ? '#5A52AE' : '#757575',
            style: _normalizeStyle(`transform: rotate(${$data.sortDirection == 'asc' ? 0 : 180}deg)`)
          }, null, 8, ["color", "style"])])]),
          _: 1
        }), _createVNode(_component_b_th, {
          class: "keyword-table-thead-background-text"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "th sortable",
            onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.onSort('score'), ["stop"]))
          }, [_createTextVNode(" Score "), _createVNode(_component_app_icon, {
            icon: `chevron-down2`,
            color: $data.sortField == 'score' ? '#5A52AE' : '#757575',
            style: _normalizeStyle(`transform: rotate(${$data.sortDirection == 'asc' ? 0 : 180}deg)`)
          }, null, 8, ["color", "style"])])]),
          _: 1
        }), _createVNode(_component_b_th, {
          class: "keyword-table-thead-background-text"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "th sortable",
            onClick: _cache[4] || (_cache[4] = _withModifiers($event => $options.onSort('search_volume'), ["stop"]))
          }, [_createTextVNode(" Search Volume "), _createVNode(_component_app_icon, {
            icon: `chevron-down2`,
            color: $data.sortField == 'search_volume' ? '#5A52AE' : '#757575',
            style: _normalizeStyle(`transform: rotate(${$data.sortDirection == 'asc' ? 0 : 180}deg)`)
          }, null, 8, ["color", "style"])])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_b_tbody, {
      class: "keyword-table-body"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.keywordsFiltered, keyword => {
        return _openBlock(), _createBlock(_component_b_tr, {
          key: keyword,
          class: "keyword-table-row"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_td, {
            class: "align-middle"
          }, {
            default: _withCtx(() => [_createVNode(_component_Popper, {
              hover: "",
              arrow: "",
              placement: "top"
            }, {
              content: _withCtx(() => [!$options.isKeywordInListing($data.currently_hovered_word) ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "hover-word",
                onClick: _cache[5] || (_cache[5] = $event => $options.addWordToSearchTerms($data.currently_hovered_word))
              }, [_createVNode(_component_app_icon, {
                icon: "add-word",
                size: "16"
              }), _createTextVNode(" Add "), _createElementVNode("span", null, _toDisplayString($data.currently_hovered_word), 1), _createTextVNode(" to search terms ")])) : _createCommentVNode("", true)]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyword.keyword.individual_words, word => {
                return _openBlock(), _createElementBlock("li", {
                  onMouseover: $event => $data.currently_hovered_word = word,
                  onClick: $event => $options.onWordClick(word),
                  class: _normalizeClass(['individual-word', {
                    'bold-and-blue': !$options.isKeywordInListing(word)
                  }])
                }, _toDisplayString(word), 43, _hoisted_18);
              }), 256))]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_b_td, {
            class: "align-middle usage"
          }, {
            default: _withCtx(() => [keyword.keyword_usage == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_19, " - ")) : (_openBlock(), _createBlock(_component_product_score, {
              key: 1,
              size: "20",
              score: keyword.keyword_usage,
              color: "#22863D",
              class: "usage-count",
              onMouseover: _cache[6] || (_cache[6] = () => {}),
              onMouseleave: _cache[7] || (_cache[7] = () => {})
            }, null, 8, ["score"]))]),
            _: 2
          }, 1024), _createVNode(_component_b_td, {
            class: "align-middle right"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(keyword.score), 1)]),
            _: 2
          }, 1024), _createVNode(_component_b_td, {
            class: "align-middle right"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(keyword.search_volume ? keyword.search_volume : "<".concat(Math.round(keyword.min_volume_search))), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)])])])]);
}